import SwipeableListItem from './SwipeableListItem';

export default SwipeableListItem;
